import { withClientErrorPage } from '@sm/webassets/ClientError';
import FourTenError from './FourTenError';

export default withClientErrorPage(FourTenError, { titularElementTag: 'h1', errorCode: 410 });
